// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { LyonRestricted } from '@lyon/components/restricted/LyonRestricted';

// ANCHOR Styles
import { BLOCK } from './styles';

export const LyonUpdateFormDesktopOnly = constant(() => (
  <Block overrides={BLOCK}>
    <LyonRestricted
      title="This page is not available for mobile."
      description="This page is viewable for desktop browser only."
    />
  </Block>
));
